import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const CardWrapper = styled.div`
    background: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
`;

export const TileWrapper = styled.div`
    padding: 20px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;

    &:not(:last-of-type) {
        border-bottom: 1px solid #f0f0f0;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
    }
`;

export const TileDescription = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: row;
    flex: 1;
    gap: 16px;

    h3 {
        font-size: 16px;
        font-weight: 600;
        margin: 0 0 6px 0;
        color: #1a1a1a;
        line-height: 1.4;
    }

    @media (max-width: 768px) {
        width: 100%;
    }
`;

export const TileIco = styled.i`
    width: 48px;
    height: 48px;
    min-width: 48px;
    border-radius: 10px;
    background: linear-gradient(135deg, #f7f7f7 0%, #eeeeee 100%);
    color: #1a1a1a;
    font-style: normal;
    font-size: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e0e0e0;
    transition: all 0.3s ease;

    ${CardWrapper}:hover & {
        background: linear-gradient(135deg, #2e2d2d 0%, #000 100%);
        color: #ffffff;
        border-color: #000;
        transform: scale(1.05);
    }
`;

export const TileParagraph = styled.div`
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 1.6;
`;

export const TileActionBlock = styled.span`
    display: flex;
    align-items: center;
    gap: 10px;

    @media (max-width: 768px) {
        width: 100%;
        justify-content: flex-start;
    }
`;

export const StatusLabel = styled.span`
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1a1a1a;
    padding: 6px 12px;
    background: #f0f0f0;
    border-radius: 6px;
    gap: 8px;

    svg {
        color: #18a785;
        width: 18px;
        height: 18px;
    }
`;

export const EnrollmentSetupLink = styled(Link)`
    text-decoration: none;
`;

export const SetupButton = styled.button`
    padding: 10px 20px;
    font-size: 14px;
    font-weight: 500;
    color: white;
    background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
 
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    white-space: nowrap;

    &:hover {
        background: linear-gradient(135deg, #c18344 0%, #000 100%);
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(193, 131, 68, 0.3);
    }

    &:active {
        transform: translateY(0);
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        transform: none;
    }
`;
